import { render, staticRenderFns } from "./TeacherAccessMenu.vue?vue&type=template&id=40498853"
import script from "./TeacherAccessMenu.vue?vue&type=script&lang=js"
export * from "./TeacherAccessMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports